import FieldDocumentAccess from "./access"
import FieldConfig from "../../../proto/field-config";

const debug = false
// const debug = "FieldDocumentAccessRead"

export default class FieldDocumentAccessRead extends FieldDocumentAccess {

    constructor(config:FieldConfig) {
        super(config)

        this.icon       = "i5-eye"
    }
}